(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-wine-header"] && !Shopify.designMode) return;
  try {
    
  var params = new URLSearchParams(window.location.search);
  var market = params.get('market');

  function updateDisplay(market) {
    var restaurants = document.querySelectorAll('.restaurant');
    restaurants.forEach(function (restaurant) {
      restaurant.classList.add('uk-hidden');
    });
    if (market) {
      var selectedRestaurants = document.querySelectorAll('.restaurant.' + market);
      selectedRestaurants.forEach(function (restaurant) {
        restaurant.classList.remove('uk-hidden');
      });
    }
  }

  function changeMarket(market, updateUrl) {
    updateDisplay(market);

    if (updateUrl !== false) {
      var newUrl = new URL(window.location);
      if (market) {
        newUrl.searchParams.set('market', market);
      } else {
        newUrl.searchParams.delete('market');
      }
      window.history.pushState({}, '', newUrl);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var filter = document.getElementById('filter');

    if (market && filter) {
      filter.value = market;
      changeMarket(market);
    }

    if (filter) {
      filter.addEventListener('change', function (e) {
        changeMarket(this.value);
      });
    }

    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      var market = params.get('market');
      if (filter) {
        if (market) {
          filter.value = market;
        } else {
          filter.value = '';
        }
      }
      changeMarket(market, false);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
